//ユーティリティクラス郡

//URL関連のヘルパークラス
export class URLHelper {
    //呼び出しURLの取得
    public getFullURL() {
        return location.href;
    }
    public getHostName() {
        return location.hostname;
    }
    public isLocalHost(){
        //LocalHostでの実行か？
        if(this.getHostName() == 'localhost'){
            return true;
        }else{
            return false;
        }
    }
    public getURLParamString() {
        return location.search;
    }
    public getURLParamObject(){
        return this.getParamObject(location.search);
    }
    public getParamObject(queryString) {

        let queryObject = {};
        if (queryString) {
            //queryString = queryString.substring(1);
            let queries = queryString.split('?'); //最初の?を取り除くため'?'で分割
            var parameters = queries[1].split('&');

            for (var i = 0; i < parameters.length; i++) {
                var element = parameters[i].split('=');

                var paramName:string = decodeURIComponent(element[0]);
                var paramValue:string = decodeURIComponent(element[1]);

                queryObject[paramName.toLowerCase()] = paramValue;
            }
        }
        return queryObject;
    }
    public getParamByName(name:string, toLower:boolean = false){
        const params = this.getURLParamObject();
        //console.log(params);
        const param = params[name];
        if(typeof(param) == 'string' && toLower) {
            return param.toLowerCase();
        }else{
            return param;
        }
    }
    public getParamByNameToBoolean(name:string, toLower:boolean = false, defaultValue:boolean=undefined):boolean{
        return this.FromStrToBoolean(this.getParamByName(name, toLower), defaultValue);
    }
    public getParamByNameToInt(name:string, toLower:boolean = false, defaultValue:number=undefined):number{
        return this.FromStrToInt(this.getParamByName(name, toLower), defaultValue);
    }
    public getParamByNameToFloat(name:string, toLower:boolean = false, defaultValue:number=undefined):number{
        return this.FromStrToFloat(this.getParamByName(name, toLower), defaultValue);
    }
    public getParamByNameToArray(name:string, toLower:boolean = false, defaultValue:number[]):number[]{
        const p:string = this.getParamByName(name, toLower);
        let pa:number[] = undefined;
        if(p){
            pa = p.split('[')[1].split(']')[0].split(',').map(Number);   //numberの配列に
        }
        //console.log(name, pa);
        if(Array.isArray(pa)&&pa.length>0){
            return pa;
        }else{
            return defaultValue;
        }
    }

    public FromStrToBoolean(str: string | undefined, defaultValue:boolean=false):boolean{
        if (typeof str == 'string') {
            return str.toLowerCase() === "true";
        } else {
            return defaultValue;
        }
    }
    public FromStrToFloat(str:string | undefined, defaultValue:number = undefined){
        if (typeof str == 'string'){
            return parseFloat(str);
        }else{
            return defaultValue;
        }
    }
    public FromStrToInt(str:string | undefined, defaultValue:number = undefined){
        if (typeof str == 'string'){
            return parseInt(str);
        }else{
            return defaultValue;
        }
    }
}

//デバッグ出力
export class XDebug {
    debugOut:boolean;
    debugElem:HTMLElement;
    constructor(_debug:string|boolean = false, public header = '', public footer = '') {
        //デバッグ用の画面表示
        if(_debug == true || _debug == '1' || _debug=='true'){
            this.debugOut = true;
        }else{
            this.debugOut = false; 
        }
        //デバッグ画面出力しない場合はデバッグ要素は非表示にする
        this.debugElem = document.querySelector('#debug');
        if(!this.debugOut && this.debugElem) this.debugElem.style.display = 'none';
    }

    Out(str:string, add=true){
    //画面デバッグ出力用関数
        if(this.debugOut){
            if(this.debugElem) {
                let debugP:HTMLElement = document.querySelector('#debug p');
                if(debugP) {
                    if(add){    //累積表示
                        debugP.innerHTML = debugP.innerHTML + " " + str;
                    }else{      //更新表示
                        debugP.innerHTML = str;
                    }
                }
            }
        }
    }

    static GetStringLine(message:string, options:string[]):string{
        let line = '';
        const delimeter = ' ';
        if (message != null) {
            line = options.reduce((total, s) => total + delimeter + s, message);
        }
        return line;
    }

    public static Log(message?: string|null, ...options: any[]): void {
        // 通常出力
        const body = this.GetStringLine(message, options);
        console.trace(body);
    }

    public static Warning(message?: string|null, ...options: string[]): void {
        // 警告出力
        const body = this.GetStringLine(message, options);
        console.trace(body, 'background: #333333; color: #00dd00');
    }

    public GetTimeStamp():string {
        const date1 = new Date();
        // Sat Feb 01 2020 20:49:28 GMT+0900 (日本標準時)
        // 2020/2/1 20:49:28
        return date1.toLocaleString();
    }
}

//コンバージョン
export class XConverter {
    public static MiliSecToDHMS(milisec: number) {
        let elapsed = milisec / 1000;
        let days = Math.floor(elapsed / (60 * 60 * 24));
        let hours = Math.floor(elapsed % (60 * 60 * 24) / (60 * 60));
        let minutes = Math.floor((elapsed % (60 * 60)) / 60);
        let seconds = Math.floor(elapsed % 60);
        return [days, hours, minutes, seconds];
    }
    public static MiliSecToDHMSString(milisec: number, m = false, h = false, d = false) {
        // m, h, d : 分・時・日がゼロでも表示するか？
        let t = this.MiliSecToDHMS(milisec);
        let dlm = ':';
        let s = this.DigitToString(t[3]);
        if (t[2] > 0 || m) {
            s = this.DigitToString(t[2]) + dlm + s;
        } else if (t[1] > 0 || h) {
            s = this.DigitToString(t[1]) + dlm + s;
        } else if (t[0] > 0 || d) {
            s = this.DigitToString(t[0]) + dlm + s;
        }
        return s;
    }
    public static DigitToString(target: number, digits = 2) {
        let s = (target + 10 ** digits).toString().substring(1);
        return s;
    }

    //ループを考慮してインデックスを修正する
    public static GetIndexWithLoop(tempIndex: number, maxIndex: number, minIndex = 0) {
        if (tempIndex < minIndex) {
            return maxIndex;
        }
        else if (tempIndex > maxIndex) {
            return minIndex;
        } else {
            return tempIndex;
        }
    }
}

//タイマー
export class XTimer {
    protected startTime;
    protected elapsedMSec = 0;
    protected pausedTime;
    protected pausedMSec = 0;
    protected isPaused = true;

    public Start() {
        //タイマ開始
        this.startTime = Date.now();    //in miliseconds since January 1th
        this.elapsedMSec = 0;
        this.pausedMSec = 0;
        this.isPaused = false;
    }
    public Stop() {
        this.elapsedMSec = 0;
        this.pausedMSec = 0;
        this.isPaused = true;
    }
    public Pause() {
        //タイマ一時停止 （一時停止時の時刻を保存）
        this.pausedTime = Date.now();
        this.isPaused = true;
    }

    public Resume() {
        //タイマ再開
        this.pausedMSec = this.pausedMSec + (Date.now() - this.pausedTime);
        this.isPaused = false;
    }

    public GetElapsedInMSec() {
        if (!this.isPaused) {
            return Date.now() - this.startTime - this.pausedMSec;
        } else {
            return this.pausedTime - this.startTime - this.pausedMSec;
        }
    }
    public GetElapsedInHMS() {
        let elapsed = this.GetElapsedInMSec() / 1000;
        let days = Math.floor(elapsed / (60 * 60 * 24));
        let hours = Math.floor(elapsed % (60 * 60 * 24) / (60 * 60));
        let minutes = Math.floor((elapsed % (60 * 60)) / 60);
        let seconds = Math.floor(elapsed % 60);
        return [days, hours, minutes, seconds];
    }
}


//簡易版インターバルタイマー（SetInterval）
export class XCountUpTimer {
    intervalId: number = 0;
    lapseTime: number = 0;

    Start(startTime = 0, interval: number = 1000, callback: Function = null) {
        // setInterval()は呼び出し元が不明になるため、window.setInterval()を使う
        this.lapseTime = startTime;
        this.intervalId = window.setInterval(() => {
            this.lapseTime += interval;
            if (callback != null) { callback(this.lapseTime); }
        }, interval);
    }

    Clear() {
        //console.log('timer cleared');
        window.clearInterval(this.intervalId);
        this.intervalId = 0;
    }
}
export class XCountDownTimer {
    intervalId: number = 0;
    lapseTime: number = 0;
    callback;
    timeup;
    running = false;

    IsRunning(){
        return this.running;
    }

    Start(startTime = 60000, interval: number = 1000, callback: Function = null, timeup: Function = null) {
        // setInterval()は呼び出し元が不明になるため、window.setInterval()を使う
        //console.log('StartCountDown');
        this.lapseTime = startTime;
        this.callback = callback;
        this.timeup = timeup;
        this.running = true;
        this.intervalId = window.setInterval(() => {
            let lapse = this.lapseTime - interval;
            if (lapse > 0) {
                //console.log('interval');
                this.lapseTime = lapse;
            } else {
                this.TimeUp();
            }
            this.CallBack();
        }, interval);
    }

    CallBack(){
        if (this.callback != null) { this.callback(this.lapseTime); }
    }

    TimeUp() {
        //Time-Up
        //console.log('timeup');
        this.lapseTime = 0.0;
        this.running = false;
        this.Clear();
        if (this.timeup != null) { 
            this.CallBack();
            this.timeup(); 
        }
    }

    Penalty(value = 10000) {
        // value: 不正解の残り時間ペナルティ（mSec）
        this.lapseTime -= value;
        if (this.lapseTime < 3) {
            this.lapseTime = 3; //ゼロにすると挙動がおかしくなるので3にした
            //this.TimeUp();    //強制的にTimeUpを呼ぶと終了画面にならないので、タイマーにまかせた
        }
    }

    Clear() {
        //console.log('timer cleared');
        window.clearInterval(this.intervalId);
        this.intervalId = 0;
        this.running = false;
    }
}


//遅延実行タイマー（SetTimeout）
export class XDelayTimer {
    delayId: number = 0;

    public ExecuteWithDelay(delay: number = 1000, callback: Function = null) {
        // setTimeout()は呼び出し元が不明になるため、window.setTimeout()を使う
        // 関数に引数がある場合は、匿名関数でラップする。function(){Function(x)}
        this.delayId = window.setTimeout(() => {
            if (callback != null) { callback(); }
        }, delay);
    }
}